import Vue from 'vue'
import Router from 'vue-router'

const Home = resolve => require(['@/views/Home'], resolve)
const Compare = resolve => require(['@/views/Compare'], resolve)
const Statistics = resolve => require(['@/views/Statistics'], resolve)
const Prime = resolve => require(['@/views/Prime'], resolve)
const PrimeFactorization = resolve => require(['@/views/PrimeFactorization'], resolve)
const PrimeEven = resolve => require(['@/views/PrimeEven'], resolve)
const PrimeList = resolve => require(['@/views/PrimeList'], resolve)
const PrimeFind = resolve => require(['@/views/PrimeFind'], resolve)
const PrimeMax = resolve => require(['@/views/PrimeMax'], resolve)
const Prime2 = resolve => require(['@/views/Prime2'], resolve)
const PrimeTwin = resolve => require(['@/views/PrimeTwin'], resolve)
const Number = resolve => require(['@/views/Number'], resolve)
const NumberDetail = resolve => require(['@/views/NumberDetail'], resolve)
const NumberCard = resolve => require(['@/views/NumberCard'], resolve)
const Property = resolve => require(['@/views/Property'], resolve)
const Point24 = resolve => require(['@/views/Point24'], resolve)
const Point24Game = resolve => require(['@/views/Point24Game'], resolve)
const Rooting = resolve => require(['@/views/Rooting'], resolve)
const Vector = resolve => require(['@/views/Vector'], resolve)
const Ratio = resolve => require(['@/views/Ratio'], resolve)
const Set = resolve => require(['@/views/Set'], resolve)
const AC = resolve => require(['@/views/AC'], resolve)
const Reverse = resolve => require(['@/views/Reverse'], resolve)
const Sum = resolve => require(['@/views/Sum'], resolve)
const Batch = resolve => require(['@/views/Batch'], resolve)
const FunCal = resolve => require(['@/views/FunCal'], resolve)
const Make = resolve => require(['@/views/Make'], resolve)
const MakePrint = resolve => require(['@/views/MakePrint'], resolve)
const MakeTrain = resolve => require(['@/views/MakeTrain'], resolve)
const Weight = resolve => require(['@/views/Weight'], resolve)
const Formula = resolve => require(['@/views/Formula'], resolve)
const GameCount = resolve => require(['@/views/GameCount'], resolve)
const GameBox = resolve => require(['@/views/GameBox'], resolve)
const Error404 = resolve => require(['@/views/error/Error404'], resolve)

Vue.use(Router)

let routes = [
    {
        path: '/',
        component: Home
    },
    {
        path: '/home',
        component: Home
    },
    {
        path: '/game/count',
        component: GameCount
    },
    { path: '/game/sort', component: resolve => require(['@/views/GameSort'], resolve) },
    { path: '/game/drag', component: resolve => require(['@/views/GameDrag'], resolve) },
    { path: '/make/fraction', component: resolve => require(['@/views/MakeFraction'], resolve) },
    { path: '/calculator/batch', component: resolve => require(['@/views/ExpBatch'], resolve) },
    { path: '/prime/euler', component: resolve => require(['@/views/PrimeEuler'], resolve) },
    { path: '/correlationCoefficient', component: resolve => require(['@/views/CorrelationCoefficient'], resolve) },
    { path: '/linearRegression', component: resolve => require(['@/views/LinearRegression'], resolve) },
    { path: '/linearInterpolant', component: resolve => require(['@/views/LinearInterpolant'], resolve) },
    {
        path: '/game/box',
        component: GameBox
    },
    {
        path: '/weight',
        component: Weight
    },
    {
        path: '/formula',
        component: Formula
    },
    {
        path: '/make',
        component: Make
    },
    {
        path: '/make/print',
        component: MakePrint
    },
    {
        path: '/make/train',
        component: MakeTrain
    },
    {
        path: '/fun',
        component: FunCal
    },
    { path: '/sum', component: Sum },
    { path: '/sum2', component: resolve => require(['@/views/Sum2'], resolve) },
    {
        path: '/batch',
        component: Batch
    },
    {
        path: '/number',
        component: Number
    },
    {
        path: '/number/card',
        component: NumberCard
    },
    {
        path: '/number/property',
        component: Property
    },
    {
        path: '/number/:number',
        component: NumberDetail
    },
    {
        path: '/compare',
        component: Compare
    },
    {
        path: '/prime',
        component: Prime
    },
    {
        path: '/prime/factorization',
        component: PrimeFactorization
    },
    {
        path: '/prime/even',
        component: PrimeEven
    },
    {
        path: '/prime/list',
        component: PrimeList
    },
    {
        path: '/prime/find',
        component: PrimeFind
    },
    {
        path: '/prime/max',
        component: PrimeMax
    },
    {
        path: '/prime/twin',
        component: PrimeTwin
    },
    {
        path: '/prime2',
        component: Prime2
    },
    {
        path: '/statistics',
        component: Statistics
    },
    { path: '/statistics2', component: resolve => require(['@/views/Statistics2'], resolve) },
    { path: '/statistics3', component: resolve => require(['@/views/Statistics3'], resolve) },
    { path: '/statistics4', component: resolve => require(['@/views/Statistics4'], resolve) },
    {
        path: '/point24',
        component: Point24
    },
    {
        path: '/point24/game',
        component: Point24Game
    },
    {
        path: '/vector',
        component: Vector
    },
    {
        path: '/ratio',
        component: Ratio
    },
    {
        path: '/rooting',
        component: Rooting
    },
    {
        path: '/set',
        component: Set
    },
    {
        path: '/ac',
        component: AC
    },
    {
        path: '/reverse',
        component: Reverse
    },
    {
        path: '*',
        component: Error404
    }
]

let router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js